import { render } from "./RentalsStatementContracts.vue?vue&type=template&id=1c9bcc18&scoped=true"
import script from "./RentalsStatementContracts.vue?vue&type=script&lang=js"
export * from "./RentalsStatementContracts.vue?vue&type=script&lang=js"

import "./RentalsStatementContracts.vue?vue&type=style&index=0&id=1c9bcc18&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9bcc18"]])

export default __exports__